const baseKey = '/v1/trader/requisits'

export const requisiteAPI = {
  baseKey,
  farm: `${baseKey}/farm`,
  create: `${baseKey}/create`,
  getRequisit: (id: string) => `${baseKey}/${id}`,
  deleteRequisit: `${baseKey}`,
  disableRequisit: (id: string) => `${baseKey}/disable/${id}`,
  enableRequisit: (id: string) => `${baseKey}/enable/${id}`,
  getMany: `${baseKey}/getmany`,
  updateRequisit: `${baseKey}/update`,
  getUnlinkedRequisites: baseKey,
  attachToFarm: `${baseKey}/attachtofarm`,
  updateRequsitesStatus: `${baseKey}/update/status`,
}
